// vanilla js
'use strict';

let THEME_PATH = '';// wp_helper.home_path + '/';

document.addEventListener('DOMContentLoaded', () => {
	loadFonts();
	correctVh();
	lazyLoad();
	mobileMenu();
	initLists();
	initQty();
	initCustomFile();
	initCheckoutSteps();
	// dev2
	initProductDetailSlider();
	initQuantityInput();
	initMapSlider();
	initShowPasswordBtn();
});

window.addEventListener('resize', () => {
	correctVh();
});

// load fonts
function loadFonts() {
	WebFont.load({
		custom: {
			families: ['Font Awesome 6 Free', 'Font Awesome 6 Brands'],
			urls: [THEME_PATH + 'css/fonts.css'],
		},
		google: {
			families: ['Lato:400,700,900', 'Montserrat:400,500,600'],
		},
	});
}

// lazyLoad Images
function lazyLoad() {
	const images = document.querySelectorAll('img.lazyload');

	if (images.length) {
		images.forEach(function (img) {
			img.onload = function () {
				img.classList.add('lazyloaded');

				if (img.classList.contains('svg-html')) {
					replaseInlineSvg(img);
				}
			};
		});

		window.addEventListener('load', (e) => {
			images.forEach(img => {
				if (img.complete && img.naturalHeight !== 0) {
					img.classList.add('lazyloaded');

					if (img.classList.contains('svg-html')) {
						replaseInlineSvg(img);
					}
				}
			});
		});
	}
}

// replaseInlineSvg
function replaseInlineSvg(el) {
	const imgID = el.getAttribute('id');
	const imgClass = el.getAttribute('class');
	const imgURL = el.getAttribute('src');

	fetch(imgURL)
		.then(data => data.text())
		.then(response => {
			const parser = new DOMParser();
			const xmlDoc = parser.parseFromString(response, 'text/html');
			let svg = xmlDoc.querySelector('svg');

			if (typeof imgID !== 'undefined') {
				svg.setAttribute('id', imgID);
			}

			if (typeof imgClass !== 'undefined') {
				svg.setAttribute('class', imgClass + ' replaced-svg');
			}

			svg.removeAttribute('xmlns:a');

			if (el.parentNode) {
				el.parentNode.replaceChild(svg, el);
			}
		});
}

// correctVh
function correctVh() {
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', vh + 'px');
}

// mobile menu
function mobileMenu() {
	const openBtn = document.querySelector('.navbar-toggler');

	if (openBtn) {
		openBtn.addEventListener('click', function (event) {
			event.preventDefault();
			if (document.body.classList.contains('menu-opened')) {
				hideMenu();
			} else {
				showMenu();
			}
		});
	}
}

function showMenu() {
	document.body.classList.add('menu-opened');
}

function hideMenu() {
	document.body.classList.remove('menu-opened');
}

function initLists() {
	document.querySelectorAll('ul, ol').forEach(list => {
		if (!list.hasAttribute('class')) {
			list.classList.add('without-class');
		}
	});
}

function initQty() {
	document.querySelectorAll('.qty-wrap').forEach(wrapEl => {
		initQtyWrap(wrapEl);
	});
}

function initQtyWrap(wrapEl) {
	const DISABLED_CLASS = 'disabled';
	const btnDecEl = wrapEl.querySelector('.btn-dec');
	const btnIncEl = wrapEl.querySelector('.btn-inc');
	const inputEl = wrapEl.querySelector('input[type="number"]');

	if (btnDecEl) {
		btnDecEl.addEventListener('click', (e) => {
			e.preventDefault();

			if (btnIncEl) {
				btnIncEl.classList.remove(DISABLED_CLASS);
			}

			let val = parseInt(inputEl.value);
			const min = (parseInt(inputEl.getAttribute('min'))) ? parseInt(inputEl.getAttribute('min')) : 0;
			if (val > min) {
				btnDecEl.classList.remove(DISABLED_CLASS);
				val--;
				inputEl.value = val;
				// $input.trigger('change');
				if (val === min) {
					btnDecEl.classList.add(DISABLED_CLASS);
				}
			} else {
				btnDecEl.classList.add(DISABLED_CLASS);
			}
		});
	}

	if (btnIncEl) {
		btnIncEl.addEventListener('click', (e) => {
			e.preventDefault();
			btnDecEl.classList.remove(DISABLED_CLASS);
			let val = parseInt(inputEl.value);
			const max = (parseInt(inputEl.getAttribute('max'))) ? parseInt(inputEl.getAttribute('max')) : 999;
			if (val < max) {
				btnIncEl.classList.remove(DISABLED_CLASS);
				val++;
				inputEl.value = val;
				// $input.trigger('change');
				if (val === max) {
					btnIncEl.classList.add(DISABLED_CLASS);
				}
			} else {
				btnIncEl.classList.add(DISABLED_CLASS);
			}
		});
	}
}

function initCustomFile() {
	document.querySelectorAll('.file-uploader input[type="file"]').forEach(inputEl => {
		const wrapEl = inputEl.closest('.file-uploader');
		['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
			wrapEl.addEventListener(eventName, preventDefaults, false)
		});


		['dragenter', 'dragover'].forEach(eventName => {
			wrapEl.addEventListener(eventName, highlight, false);
		});

		['dragleave', 'drop'].forEach(eventName => {
			wrapEl.addEventListener(eventName, unhighlight, false);
		});

		wrapEl.addEventListener('drop', handleDrop, false);

		function handleDrop(e) {
			let dt = e.dataTransfer;
			let files = dt.files;

			handleFiles(files);
		}

		function handleFiles(files) {
			inputEl.files = files;
			([...files]).forEach(uploadFile);
		}

		function uploadFile(file) {
			let formData = new FormData();

			formData.append('file', file)

			wrapEl.querySelector('.file-str').innerText = file.name;
			wrapEl.classList.add('prepared');

			// const url = 'YOUR URL HERE';
			// fetch(url, {
			// 	method: 'POST',
			// 	body: formData
			// })
			// .then(() => { /* Done. Inform the user */ })
			// .catch(() => { /* Error. Inform the user */ });
		}

		function highlight(e) {
			wrapEl.classList.add('highlight');
		}

		function unhighlight(e) {
			wrapEl.classList.remove('highlight');
		}

		function preventDefaults(e) {
			e.preventDefault();
			e.stopPropagation();
		}
	});
}

function initCheckoutSteps() {
	const ACTIVE_CLASS = 'active';
	const PASSED_CLASS = 'passed';

	// masks
	document.querySelectorAll('.checkout-block form').forEach(formEl => {
		formEl.querySelectorAll('.card-num-control').forEach(cardNumEl => {
			let mask = IMask(cardNumEl, {
				mask: '0000 0000 0000 0000',
			});
		});

		formEl.querySelectorAll('.card-exp-control').forEach(cardExpEl => {
			let mask = IMask(cardExpEl, {
				mask: 'MM{/}YY',
				blocks: {
					MM: {
						mask: IMask.MaskedRange,
						from: 1,
						to: 12,
						maxLength: 2,
					},
					YY: {
						mask: IMask.MaskedRange,
						from: 0,
						to: 99,
						maxLength: 2,
					},
				},
			});
		});

		formEl.querySelectorAll('.card-cvv-control').forEach(cardCodeEl => {
			let mask = IMask(cardCodeEl, {
				mask: '000',
			});
		});
	});

	document.querySelectorAll('.cart-section .checkout-block input[type="checkbox"][data-target]').forEach(checkEl => {
		checkGroupState();

		checkEl.addEventListener('change', (e) => {
			checkGroupState();
		});

		function checkGroupState() {
			const targetEl = document.querySelector(checkEl.dataset.target);
			if (targetEl) {
				if (checkEl.checked) {
					targetEl.classList.add('hidden');
				} else {
					targetEl.classList.remove('hidden');
				}
			}
		}
	});

	// steps
	document.querySelectorAll('.cart-section .checkout-block').forEach(wrapEl => {
		const stepEls = wrapEl.querySelectorAll('.step-box');

		wrapEl.querySelectorAll('.step-box-head h2, .step-box-head .h2').forEach(headEl => {
			headEl.addEventListener('click', (e) => {
				const stepEl = headEl.closest('.step-box');
				let ix = -1;

				if (!stepEl.classList.contains(ACTIVE_CLASS)) {
					stepEls.forEach((el, i) => {
						if (stepEl === el) {
							stepEl.classList.add(ACTIVE_CLASS);
							stepEl.classList.remove(PASSED_CLASS);
							ix = i;
						} else {
							el.classList.remove(ACTIVE_CLASS);
							if (ix === -1 || ix > i) {
								el.classList.add(PASSED_CLASS);
							} else {
								el.classList.remove(PASSED_CLASS);
							}
						}
					});

					if (ix === stepEls.length - 1) {
						wrapEl.classList.add('is-filled');
					}

					setTimeout(() => {
						goToTarget(stepEl);
					}, 100);
				}
			});
		});
	});
}

function goToTarget(target) {
	const targetEl = isElement(target) ? target : document.querySelector(target);
	if (!targetEl) return false;

	const pos = targetEl.getBoundingClientRect().top + window.scrollY - getTopOffset();
	window.scrollTo({
		top: pos,
		behavior: 'smooth'
	});

	setTimeout(() => {
		const pos = targetEl.getBoundingClientRect().top + window.scrollY - getTopOffset();
		if (window.scrollY < pos) {
			window.scrollTo({
				top: pos,
				behavior: 'smooth'
			});
		}
	}, 500);
}

function isElement(element) {
	return element instanceof Element || element instanceof HTMLDocument;
}

function getTopOffset() {
	const headerEl = document.querySelector('#header');
	return headerEl ? headerEl.offsetHeight : 0;
}

//dev2

function initProductDetailSlider() {
	const sliderEls = document.querySelectorAll('.product-detail-gallery-holder');

	if (sliderEls.length) {
		Array.from(sliderEls).forEach(sliderEl => {
			const btnPrev = sliderEl.querySelector('.swiper-button-prev');
			const btnNext = sliderEl.querySelector('.swiper-button-next');

			const swiper2 = new Swiper(sliderEl.querySelector('.swiper-thumbs'), {
				direction: 'horizontal',
				spaceBetween: 14,
				loop: false,
				freeMode: true,
				// watchSlidesVisibility: true,
				watchSlidesProgress: true,
				breakpoints: {
					320: {
						slidesPerView: 2,
					},
					768: {
						slidesPerView: 3,
					},
					1200: {
						slidesPerView: 4
					}
				}
			});

			const swiper3 = new Swiper(sliderEl.querySelector('.swiper-gallery'), {
				direction: 'horizontal',
				spaceBetween: 0,
				loop: false,
				navigation: {
					nextEl: btnNext,
					prevEl: btnPrev,
				},
				thumbs: {
					swiper: swiper2,
					clickable: true
				},
			});
		});
	}
}

function initQuantityInput() {
	const inputWrapper = document.querySelectorAll(".input-quantity-wrapper");

	if (inputWrapper) {
		inputWrapper.forEach(item => {
			item.children[0].addEventListener('click', event => {
				event.preventDefault();
				let inputValue = item.children[1].value;
				inputValue > 1 ? inputValue-- : 1;
				item.children[1].value = inputValue;
			});

			item.children[2].addEventListener('click', event => {
				event.preventDefault();
				let inputValue = item.children[1].value;
				inputValue++;
				item.children[1].value = inputValue;
			});
		});
	}
}

function initMapSlider() {
	const sliderEls = document.querySelectorAll('.swiper-maps');

	if (sliderEls.length) {
		Array.from(sliderEls).forEach(sliderEl => {
			const btnPrev = sliderEl.closest('.slider-holder').querySelector('.swiper-button-prev');
			const btnNext = sliderEl.closest('.slider-holder').querySelector('.swiper-button-next');

			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				slidesPerView: 1,
				loop: false,
				navigation: {
					nextEl: btnNext,
					prevEl: btnPrev,
				},
			});
		});
	}
}

function initShowPasswordBtn() {
	let btns = document.querySelectorAll('.show-pass-btn');
	if (!btns.length) return;

	btns.forEach(el => {
		el.addEventListener('click', e => {
			e.preventDefault();
			let parent = el.closest('.form-group-password');
			if (!parent.classList.contains('password-shown')) {
				parent.classList.add('password-shown');
				parent.querySelector('.form-control').setAttribute('type', 'text');
			} else {
				parent.classList.remove('password-shown');
				parent.querySelector('.form-control').setAttribute('type', 'password');
			}
		});
	});
}

// jQuery
(function ($) {
	$(document).ready(function () {
	}); // ready

	$(window).on('resize', function () {
	}); // resize

	$(window).on('load', function () {
	}); // load

	// jQuery functions
})(this.jQuery);